import { gridSize, gridSizeMdLg12, gridSizeMdLg9, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { GeneralTable, SampleTable, SearchComponente, TabTextLabel } from "@/shared/components/ui";
import { Button, Grid, Paper } from "@mui/material";
import useTableColumnsRegistroFacturas from "../../hook/useTableColumnsRegistroFacturas";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useGastos } from "@/store/erp/gastos/useGastos";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useFetchGastos } from "@/shared/actions/erp";
import { Gastos } from "@/shared/interfaces/erp/inventario";
import { TreeNode } from "@/shared/interfaces";

export default function RegistroFacturaGastos() {
  //store
  const gastos = useGastos(s => s.gastos)
  const paginatedData = useGastos(s => s.paginatedData)
  const paginationGasto = useGastos(s => s.pagination)
  const setPaginationGasto = useGastos(s => s.setPagination)
  const handleAgregarGasto = useGastos(s => s.handleAgregarGasto)
  //state
  const [isOpeneModal, setIsOpenModal] = useState(false)

  //hook
  const {
    columnsInfoGasto,
    columnsGastos,
    columnsCuentasContable,
    details,
    isOpenModal2,
    setOpenModal2
  } = useTableColumnsRegistroFacturas()
  const {
    pagination,
    setPagination,
    globalFilter,
    //setGlobalFilter,
    onChangeFilter,
    searchTerm,
    //cleanFilter,
  } = useTableFilter()
  const { pageIndex, pageSize } = pagination
  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()
  const {
    data: dataGastos,
    isLoading: isLoadingGastos
  } = useFetchGastos({
    page: pageIndex + 1,
    page_size: pageSize,
    descripcion: searchTerm,
    ...filterObject,
    filterByState: false
  })
  //console.log('gastos', dataGastos)

  const onChangeAux = (e: Gastos) => {
    const costo_base = Number(e.costo)
    const ivaPorcentaje = parseFloat(e.iva.replace("IVA", "").replace("%", ""))
    const icePorcentaje = parseFloat(e.ice.replace("ICE", "").replace("%", ""))

    const valorICE = costo_base * (icePorcentaje / 100)
    const subtotal_sin_iva = costo_base
    const valor_iva = subtotal_sin_iva * (ivaPorcentaje / 100)
    const subtotal_con_iva = subtotal_sin_iva + valor_iva
    const total = subtotal_sin_iva + valor_iva + valorICE

    const aux: Gastos = {
      id_gasto: e.id_gasto,
      costo: e.costo,
      ice: e.ice,
      nombre: e.nombre,
      codigo: e.codigo,
      cuentas_contables: e.cuentas_contables,
      descripcion: e.descripcion,
      proveedor: e.proveedor,
      iva: e.iva,
      valor_iva: valor_iva.toString(),
      valorICE: valorICE.toString(),
      subtotal_sin_iva: subtotal_sin_iva.toString(),
      subtotal_con_iva: subtotal_con_iva.toString(),
      total: total.toString()
    }
    handleAgregarGasto(aux)
  }

  return (
    <>
      <Grid item {...gridSize}>
        <Paper className="paper-producto">
          <Grid container spacing={1} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item>
              <TabTextLabel text={"Gastos Seleccionados"} mt={0} pb={0} pl={0} pt={0} />

            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => setIsOpenModal(true)}
                endIcon={<AddCircleIcon />}
              >
                {'Agregar Gasto'}
              </Button>
            </Grid>
            <div className="linea" />
            <Grid item xs={12}>
              <SampleTablePagination
                columns={columnsInfoGasto}
                data={paginatedData}
                pagination={paginationGasto}
                setPagination={setPaginationGasto}
                rowCount={gastos.length}
              />
            </Grid>
          </Grid>

        </Paper>
      </Grid>
      {
        isOpeneModal && (
          <ScrollableDialogProps
            title="Gastos"
            open={isOpeneModal}
            onCloseIcon={() => setIsOpenModal(false)}
            minWidth="60%"
            contentNode={
              <>
                <Grid item {...gridSize}>
                  <Paper className="Paper-producto">
                    <Grid container spacing={3} alignItems={"center"}>
                      <Grid item {...gridSizeMdLg9} >

                        <SearchComponente
                          value={globalFilter}
                          text="por descripción"
                          onChange={onChangeFilter}
                        />
                      </Grid>

                      <Grid item {...gridSizeMdLg12}>
                        <div className="linea" />
                      </Grid>

                      <Grid item xs={12}>
                        <GeneralTable
                          columns={columnsGastos}
                          data={dataGastos?.data.data || []}
                          isLoading={isLoadingGastos}
                          rowCount={dataGastos?.data.count}
                          enableGlobalFilter={false}
                          pagination={pagination}
                          onPaging={setPagination}
                          columnFilters={columnFilters}
                          onColumnFiltersChange={setColumnFilters}
                          enableManualFiltering={true}
                          enableSorting={false}
                          canEdit={false}
                          canAdd={true}
                          onAdd={e => {
                            onChangeAux(e)
                          }}
                        />

                      </Grid>

                    </Grid>
                  </Paper>

                </Grid>
              </>
            }
          />

        )
      }
      <ScrollableDialogProps
        open={isOpenModal2}
        onCloseIcon={() => setOpenModal2(false)}
        title="Cuenta Contable"
        contentNode={
          <>
            <SampleTable<TreeNode>
              columns={columnsCuentasContable}
              data={details}
            />
          </>
        }
      />

    </>

  )
}